import React from 'react';
import { useIntl } from 'react-intl';

import { PAGE_HEIGHT_WITHOUT_NAV } from '~/common/constants/page';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';

import { Contents } from './Contents';
import { Header } from './Header';

export const ClauseLibraryPage = () => {
  const intl = useIntl();

  return (
    <PageLayout
      header={<Header />}
      height={PAGE_HEIGHT_WITHOUT_NAV}
      title={intl.formatMessage({
        id: 'ClauseLibraryPage.title',
        defaultMessage: 'Clause Library',
        description: 'Page title for the clause library',
      })}
    >
      <Contents />
    </PageLayout>
  );
};
